import { Toast } from 'antd-mobile';
export const phoneRegExg = /^1[0-9]{10}$/;
export const invariant =(type:any , msg: string)=> {
    if(!type){
        Toast.info(msg)
        return false; 
    }
    return true; 

}